import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import PropTypes from 'prop-types';
import React from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetView from "./FacetView";
export default function ConjunctiveFacet(props) {
  const isSelectedValue = facetProductValue => props.filters.get(props.facet.get('key')) === facetProductValue;
  const createNewFilters = facetProduct => props.filters.get(props.facet.get('key')) === facetProduct ? props.filters.delete(props.facet.get('key')) : props.filters.set(props.facet.get('key'), facetProduct);
  const fireAnalyticsEvent = useAnalyticsEvents();
  return /*#__PURE__*/React.createElement(FacetView, {
    closeOnItemSelected: true,
    createNewFilters: createNewFilters,
    facet: props.facet,
    filters: props.filters,
    fireAnalyticsEvent: fireAnalyticsEvent,
    hiddenFilters: props.hiddenFilters,
    isSelectedValue: isSelectedValue,
    itemFactory: props.itemFactory,
    FacetComponent: props.FacetComponent,
    onFacetProductClick: props.onFacetProductClick,
    perspective: props.perspective,
    sortingLogicForCategory: props.sortingLogicForCategory,
    stateChangeRequested: props.stateChangeRequested
  });
}
ConjunctiveFacet.propTypes = {
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  FacetComponent: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  sortingLogicForCategory: PropTypes.string,
  stateChangeRequested: PropTypes.func.isRequired
};